export const FOOD_OFTEN_EAT = [
    "avocado",
    "salmon",
    "blueberries",
    "chicken",
    "greek-yogurt",
    "raspberries",
    "egg",
    "strawberry",
    "quinoa",
    "broccoli",
    "tomato",
    "bell-pepper",
    "asparagus",
    "shrimp",
    "almonds",
    "cucumber",
    "garlic",
    "spinach",
    "feta-cheese",
    "mango",
    "walnuts",
    "pineapple",
    "zucchini",
    "beef"
]
export const FOOD_DISLIKE_EAT = [
    "turkey",
    "tofu",
    "cheese-wedge", // alt="Cheese wedge"
    "salmon",
    "onion",
    "cauliflower",
    "coconut-milk", // alt="Coconut milk"
    "zucchini",
    "brussels-sprouts", // alt="Brussels sprouts"
    "black-olives", // alt="Black olives"
    "radishes",
    "egg",
    "bell-pepper", // alt="Bell pepper"
    "edamame",
    "shrimp",
    "celery",
    "lentils",
    "peas",
    "canned-tuna", // alt="Canned tuna"
    "chia-seeds", // alt="Chia seeds"
    "pumpkin",
    "garlic",
    "spinach",
    "beef",
];

export const SMART_MOBILE_APP_IMAGES = [
    "/static/image/questionnaire/fasting/payScreen/app-gallery-fasting-diary.png",
    "/static/image/questionnaire/fasting/payScreen/app-gallery-food-log.png",
    "/static/image/questionnaire/fasting/payScreen/app-gallery-food-scan.png",
];
export const WEIGHT_LOSS_REAL_USERS_EXPERIENCES_MALE = [{
    image: "/static/image/questionnaire/fasting/payScreen/PayMaleWeightLossOne.png",
    content: "I've tried dieting so many times, but fasting was the first thing that actually felt simple. The plan kept me consistent, and I finally started seeing real changes.",
    name: "-Mark 10/3/2024",
},{
    image: "/static/image/questionnaire/fasting/payScreen/PayMaleWeightLossTwo.png",
    content: "What I liked most was how easy it was to follow. I didn't have to overthink every meal, and the routine helped me stay on track.",
    name: "-Alex  5/13/2025",
},{
    image: "/static/image/questionnaire/fasting/payScreen/PayMaleWeightLossThree.png",
    content: "I was skeptical at first, but this made fasting feel realistic for everyday life. I feel more in control, and the results have been motivating.",
    name: "-Steve  4/21/2025",
}
];
export const WEIGHT_LOSS_REAL_USERS_EXPERIENCES_FEMALE = [{
    image: "/static/image/questionnaire/fasting/payScreen/PayFemaleWeightLossOne.png",
    content: "I love that it gives me structure without feeling too restrictive. It helped me build healthier habits instead of just doing another short-term diet.",
    name: "-Emy  4/10/2025",
},{
    image: "/static/image/questionnaire/fasting/payScreen/PayFemaleWeightLossTwo.png",
    content: "This is the first plan that actually fit into my schedule. The guidance made fasting feel manageable, and I've been much more consistent.",
    name: "-Rachel   11/10/2024",
},{
    image: "/static/image/questionnaire/fasting/payScreen/PayFemaleWeightLossThree.png",
    content: "I've noticed not just changes in my weight, but also in how confident I feel. It feels less like dieting and more like a routine I can actually maintain.",
    name: "-Laura 6/12/2025",
}
];

export const CREATING_PLAIN_COMMENT = [{
    content: "Super easy way to track my calories and meals! Love it!!eals! Love it!!",
    name:"- Anna"
},{
    content: "I’ve lost 5 pounds in just one week since I started using this app! Being able to keep track of my calories and monitor my fasting has made such a difference.",
    name:"-Alex"
},{
    content: "Dropping 10 lbs of fat with Calo really brought out my abs. Essential for next-level results!",
    name:"-Emy"
}];

export const HEALTH_CONCERNS = [
    { value: 'Hypertension' },
    { value: 'High cholesterol' },
    { value: 'Obesity' },
    { value: 'Diabetes' },
    { value: 'Heart disease' },
    { value: 'Kidney disease' },
    { value: 'Cancer' },
    { value: 'Lung disease' },
    { value: 'Thyroid disease' },
    { value: 'Gastric disease' }
];
export const DIETARY_PREFERENCE = [
    { content: 'Balanced' },
    { content: 'Keto' },
    { content: 'Low carbs' },
    { content: 'Vegetarian' },
    { content: 'Vegan' },
    { content: 'Mediterranean' },
    { content: 'Paleo' },
    { content: 'High protein' },
    { content: 'Low fat' }
];
export const SKIN_CHANGES = [
    { value: "None, I have perfect skin", isNone: true },
    { value: "Acne and blemishes" },
    { value: "Dark spots and pores" },
    { value: "Dryness" },
    { value: "Fine lines and wrinkles" },
    { value: "Dullness and texture" },
    { value: "Other" }
];

export const ACTIVITY_LEVEL = [{
    content: "Sedentary: ",
    value: "Sedentary",
    subcontent: "I sit or lie down most of the day"
},{
    content: "Lightly Active: ",
    value: "Lightly Active",
    subcontent: "I walk or do light chores"
},{
    content: "Moderately Active: ",
    value: "Moderately Active",
    subcontent: "I exercise regularly or move a lot at work"
},{
    content: "Very Active: ",
    value: "Very Active",
    subcontent: "I do physical activities all day"
}];
export const RESULTS_TIMING = [{
    content: "Within a month",
    value: "Within a month"
},{
    content: "1-3 months",
    value: "1-3 months"
},{
    content: "3-6 months",
    value: "3-6 months"
},{
    content: "I am here for the long term",
    value: "I am here for the long term"
}];
export const MEAL_COUNT = [{
    content: "Three meals",
    subcontent: "(breakfast, lunch, dinner)",
},{
    content: "Four meals",
    subcontent: "(breakfast, lunch, dinner, snack)",
}];
export const HEARD_FASTING = [
    {
        content: "Just the name",
        value: "just_the_name"
    },
    {
        content: "I know a few things",
        value: "know_a_few_things"
    },
    {
        content: "Yes, I know everything about it!",
        value: "know_everything"
    }
];
export const ALLERGY = [
    { value: 'Gluten' },
    { value: 'Dairy' },
    { value: 'Nut' },
    { value: 'Seafood' },
    { value: 'Egg' }
];
